import axios from "axios";
import {BASE_API_URL} from "constants.js";
import {LocalStorageService} from "services/utils/local-storage-service";
import {AUTH_STORAGE_KEY} from "store/reducer/auth/reducer";

const apiClient = axios.create({
    baseURL: BASE_API_URL,
    headers: {
        common: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    }
});

export const setupAxiosInterceptors = (onUnauthenticated) => {
    apiClient.interceptors.request.use((config) => {
        const token = (JSON.parse(LocalStorageService.getItem(AUTH_STORAGE_KEY)) || {}).token;
        if( token ) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });
    apiClient.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        if (error.response && error.response.status === 401) {
            onUnauthenticated();
        }
        throw error;
    });
}


export default apiClient;
